import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";

const HowItWorksSection = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery("(max-width: 1199px)");
  return (
    <Box
      sx={{
        py: { xs: 6, lg: 8 },
        px: { xs: 2, lg: 2 },
        maxWidth: { xs: "100%", md: "1420px" },
        mx: "auto",
        textAlign: "center",
      }}>
      <Typography
        sx={{
          fontFamily: "var(--font-poppins)",
          fontSize: { xs: "28px", lg: "32px" },
          fontWeight: 800,
          color: theme.palette.primary.main,
          mb: { xs: 4, lg: 6 },
        }}>
        How it works?
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "start",
          justifyContent: "space-between",
          gap: { xs: 4, lg: 0 },
        }}>
        {/* Step 1 */}
        <Box sx={{ textAlign: "center", maxWidth: "300px", mx: "auto" }}>
          <Image
            src="/images/HowItWorks1.png"
            alt="Step 1"
            width={150}
            height={150}
          />
          <Typography
            sx={{
              mt: 2,
              fontFamily: "var(--font-poppins)",
              fontSize: { xs: "18px", lg: "20px" },
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}>
            Sign up for free
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontFamily: "RethinkSans, sans-serif",
              fontSize: { xs: "14px", lg: "16px" },
              color: "#212529",
              lineHeight: 1.6,
            }}>
            Create your NestShipper account in seconds. No credit card required.
          </Typography>
        </Box>

        {/* Arch Downwards */}
        {!isSmallMobile && (
          <Image
            src="/images/ArchUpwards.png"
            alt="Arrow Upwards"
            width={220}
            height={50}
            style={{ marginTop: "76px" }}
          />
        )}

        {/* Step 2 */}
        <Box sx={{ textAlign: "center", maxWidth: "300px", mx: "auto" }}>
          <Image
            src="/images/HowItWorks2.png"
            alt="Step 2"
            width={150}
            height={150}
          />
          <Typography
            sx={{
              mt: 2,
              fontFamily: "var(--font-poppins)",
              fontSize: { xs: "18px", lg: "20px" },
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}>
            Connect your marketplaces
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontFamily: "RethinkSans, sans-serif",
              fontSize: { xs: "14px", lg: "16px" },
              color: "#212529",
              lineHeight: 1.6,
            }}>
            Link platforms like Etsy, Shopify, Amazon or Walmart with just a few
            clicks.
          </Typography>
        </Box>

        {/* Arch Upwards */}
        {!isSmallMobile && (
          <Image
            src="/images/ArchDownwards.png"
            alt="Arrow Downwards"
            width={220}
            height={50}
            style={{ marginTop: "28px" }}
          />
        )}

        {/* Step 3 */}
        <Box sx={{ textAlign: "center", maxWidth: "300px", mx: "auto" }}>
          <Image
            src="/images/HowItWorks3.png"
            alt="Step 3"
            width={150}
            height={150}
          />
          <Typography
            sx={{
              mt: 2,
              fontFamily: "var(--font-poppins)",
              fontSize: { xs: "18px", lg: "20px" },
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}>
            Start shipping and save up to 90%
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontFamily: "RethinkSans, sans-serif",
              fontSize: { xs: "14px", lg: "16px" },
              color: "#212529",
              lineHeight: 1.6,
            }}>
            Automatically sync your orders and create shipping labels with
            discounted rates from top carriers.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HowItWorksSection;
